export default class GameChange {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default(data) {
        debugger
        this.gb.emitters.emit.web.gameChange(data);
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            default:
                event["openGame"] = this._default;
        }

        return event;
    }
}